import { Graph } from '@antv/g6';
import { deepMix } from '@antv/util';
import { DeepPartial } from 'utils/tsHelpers';
import { globalKey } from '../constants';
import { Global } from '../global';

/**
 * Retrieves our additional config from the graph
 */
export const getGlobal = (graph?: Graph | null): Global => graph?.get(globalKey) || new Global();

/**
 * Sets config to the graph
 */
export const setGlobal = (graph?: Graph | null, config?: Global) => {
  if (!graph || !config) return;
  graph.set(globalKey, config);
};

/**
 * Updates our global config
 */
export const updateGlobal = (graph?: Graph | null, config: DeepPartial<Global> = {}) => {
  if (!graph) return;
  const currentConfig = getGlobal(graph);
  setGlobal(graph, deepMix({}, currentConfig, config));
};
